import React from 'react';

const Icon = ({ size = '42', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 42 42" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeWidth="1.948">
                <path
                    d="m32.473 29.22-1.214-10.316a.65.65 0 0 1 .645-.726h1.218a1.948 1.948 0 0 0 1.949-1.948V8.437a1.948 1.948 0 0 0-1.949-1.949h-12.68c-.18 0-.358.025-.531.074l-4.324 1.225v9.093l4.302.268a6.494 6.494 0 0 1 6.09 6.482v5.59M7.793 14.282v-3.897L9.98 9.292c.27-.136.569-.206.871-.206h4.736v6.495H10.85c-.302 0-.6-.071-.871-.206l-2.187-1.093Z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                <path d="M7.793 12.334H3.897m24.029 2.725-1.948-3.375m5.845 3.375-1.948-3.375" strokeLinecap="round" />

                <path d="M23.38 29.545h10.392c.179 0 .324.145.324.324v6.494c0 .18-.145.325-.324.325H19.484a.325.325 0 0 1-.325-.325v-2.597a4.221 4.221 0 0 1 4.004-4.216l.217-.005Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M0-.006h41.565v41.565H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
